import { ModelBase } from 'store/model-base';

export class CmsTravelRates extends ModelBase {
    public static storeName: string = 'cmsTravelRates';

    public travelRates: CmsInternationalTravelRates;
}
